namespace TabAurous.ECommerce {
    export namespace ECommSalesDayWiseService {
        export const baseUrl = 'ECommerce/ECommSalesDayWise';

        export declare function List(request: Serenity.ListRequest, onSuccess?: (response: Serenity.ListResponse<ECommSalesReportRow>) => void, opt?: Q.ServiceOptions<any>): JQueryXHR;

        export declare const enum Methods {
            List = "ECommerce/ECommSalesDayWise/List"
        }

        [
            'List'
        ].forEach(x => {
            (<any>ECommSalesDayWiseService)[x] = function (r, s, o) {
                return Q.serviceRequest(baseUrl + '/' + x, r, s, o);
            };
        });
    }
}
